<script lang="ts">
	import StarIcon from 'assets/svg/starEmptyTable.svg?component';
	import WatchlistModal from 'components/WatchlistModal/WatchlistModal.svelte';
	import { _ } from 'utils/i18/i18n';

	export let dark = false;
	export let uid = '';
	export let list = [];
	export let listName = '';

	let addToWatchlistModalIsOpened = false;

	const handleAddBtnClick = () => {
		addToWatchlistModalIsOpened = !addToWatchlistModalIsOpened;
	};
</script>

<div class="text-wrapper" class:dark>
	<StarIcon class="empty-watchlist-icon" width={40} height={40} />
	<p class="main-text">{$_('watchlist.EmptyListText1')}</p>
	<p class="sub-text">{$_('watchlist.EmptyListText2')}</p>
	<button class="add-coins" on:click={() => (addToWatchlistModalIsOpened = true)}
		>{$_('watchlist.addCoins')}</button
	>

	{#key list}
		<WatchlistModal
			{dark}
			{uid}
			bind:active={addToWatchlistModalIsOpened}
			toggleModal={handleAddBtnClick}
			{listName}
		/>
	{/key}
</div>

<style lang="scss">
	@import 'emptyWatchlistBlock';
</style>
